<form class="itinerary-model-content-inner" [formGroup]="userForm" *ngIf="userForm">
  <div class="itinerary-model-content">
    <div class="ion-no-padding">
      <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">User Details</ion-title>
    </div>

    <div class="form-container ion-padding-horizontal">
      <div class="row">
        <div class="col-4">
          <div class="input-container">
            <label for="" class="label">Profile Picture</label>
            <div [ngClass]="{ 'invalid-input': userForm.get('imageDoc')?.invalid && userForm.get('imageDoc')?.touched }">
              <div class="file-view" *ngIf="userForm.get('imageDoc')?.value">
                <div class="d-flex justify-content-between align-items-center">
                  <p class="clickable-text mb-0" style="font-size: 12px; font-weight: 600;" (click)="openAttachment(userForm.get('imageDoc')?.value)">View Uploaded Image</p>
                  <div class="d-flex">
                    <label for="organizationImageInput" class="unfilled-gray-btn px-2 my-1">
                      Reupload
                    </label>
                    <ion-button class="unfilled-red-btn" (click)="deleteProfileImage()">Delete</ion-button>
                  </div>
                </div>
              </div>
              <div [ngClass]="{'d-none' : userForm.get('imageDoc')?.value}">
                <input type="file" id="organizationImageInput" class="input" accept="image/*" (change)="onProfileChange($event)">
              </div>
            </div>
          </div>
        </div>

        <div class="col-4">
          <div class="input-container">
            <label for="first-name" class="label">First Name*</label>
            <div [ngClass]="{ 'invalid-input': userForm.get('firstName')?.invalid && userForm.get('firstName')?.touched }">
              <input class="input-text input" type="text" id="first-name" placeholder="Enter First Name" formControlName="firstName">
            </div>

          </div>
        </div>

        <div class="col-4">
          <div class="input-container">
            <label for="last-name" class="label">Last Name*</label>
            <div
              [ngClass]="{ 'invalid-input': userForm.get('lastName')?.invalid && userForm.get('lastName')?.touched }">
              <input class="input-text input" type="text" id="last-name" placeholder="Enter Last Name" formControlName="lastName">
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-4">
          <div class="input-container">
            <label for class="label">Email ID*</label>
            <div [ngClass]="{ 'invalid-input': userForm.get('email')?.invalid && userForm.get('email')?.touched }">
              <input class="input input-text" placeholder="Email Address" formControlName="email" type="email" />
            </div>
            <div *ngIf="userForm.get('email')?.hasError('emailTaken') && userForm.get('email')?.touched">
              <span class="warning-message">Admin user already exists with this email</span>
            </div>
          </div>
        </div>

        <div class="col-4">
          <div class="input-container">
            <label for class="label">Official Phone Number *</label>
            <div
              [ngClass]="{ 'invalid-input': userForm.get('officePhoneNumber')?.invalid && userForm.get('officePhoneNumber')?.touched }">
              <app-phone-country-input formControlName="officePhoneNumber"></app-phone-country-input>
            </div>
          </div>
        </div>

        <div class="col-4">
          <div class="input-container">
            <label for class="label">Personal Phone Number</label>
            <div
              [ngClass]="{ 'invalid-input': userForm.get('personalPhoneNumber')?.invalid && userForm.get('personalPhoneNumber')?.touched }">
              <app-phone-country-input formControlName="personalPhoneNumber"></app-phone-country-input>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-4">
          <div class="input-container">
            <label for="date-of-birth" class="label">Date Of Birth</label>
            <div [ngClass]="{ 'invalid-input': userForm.get('dateOfBirth')?.invalid && userForm.get('dateOfBirth')?.touched }">
              <app-date-picker formControlName="dateOfBirth" [maxDate]="today"></app-date-picker>
            </div>
          </div>
        </div>

        <div class="col-4">
          <div class="input-container">
            <label for="gender" class="label">Gender*</label>
            <div [ngClass]="{ 'invalid-input': userForm.get('gender')?.invalid && userForm.get('gender')?.touched }">
              <select class="input" formControlName="gender">
                <option value="" hidden>-- Gender --</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Others">Others</option>
                <option value="Prefer not to say">Prefer not to say</option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-4">
          <div class="input-container">
            <label for="onBoardedDate" class="label"> On-board Date</label>
            <div [ngClass]="{ 'invalid-input': userForm.get('onBoardedDate')?.invalid && userForm.get('onBoardedDate')?.touched }">
              <app-date-picker formControlName="onBoardedDate"></app-date-picker>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-4">
          <div class="input-container">
            <label for="activationDate" class="label"> Activation Date</label>
            <div [ngClass]="{ 'invalid-input': userForm.get('activationDate')?.invalid && userForm.get('activationDate')?.touched }">
              <app-date-picker formControlName="activationDate" [minDate]="convertToDate(userForm.get('onBoardedDate')?.value)"></app-date-picker>
            </div>
          </div>
        </div>

        <div class="col-4">
          <div class="input-container">
            <label for="department" class="label">Department*</label>
            <div [ngClass]="{ 'invalid-input': userForm.get('department')?.invalid && userForm.get('department')?.touched }">
              <select class="input" formControlName="department">
                <option value="" hidden>-- Department --</option>
                <option value="admin">Sales and Marketing</option>
                <option value="Supervisor">Customer Service</option>
                <option value="user">Operations</option>
                <option value="finance and accounting">Finance and Accounting</option>
                <option value="visa User">Visa</option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-4">
          <div class="input-container">
            <label for="roleIdentifier" class="label">Role*</label>
            <div [ngClass]="{ 'invalid-input': userForm.get('roleIdentifier')?.invalid && userForm.get('roleIdentifier')?.touched }">
              <!-- TODO: use LOV data here -->
              <select class="input" formControlName="roleIdentifier">
                <option value="" hidden>-- Role --</option>
                <option value="ClientAdmin">ClientAdmin</option>
                <option value="ClientManager">ClientManager</option>
                <option value="ClientSupervisor">ClientSupervisor </option>
                <option value="ClientUser">ClientUser</option>
                <option value="ClientVisa">ClientVisa</option>
                <option value="ClientAccountant">ClientAccountant</option>
                <option value="ClientDemo">ClientDemo</option>
              </select>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div class="ion-padding-horizontal bg-light-gray justify-content-center itinerary-model-footer">
    <ion-button class="unfilled-blue-btn" (click)="goPrevious()" [hidden]="true" [disabled]="formDataModified()">
      <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
      Reset
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified()">
      Save
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified()">
      Save & Next
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="goNextTab()" [disabled]="!userId || formDataModified()">
      <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>
</form>